import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Affirmation} from '../../../../models/applicationFeature';
import {CommonService} from '../../../../services/common.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';

@Component({
  selector: 'app-affirmation-card',
  templateUrl: './affirmation-card.component.html',
  styleUrls: ['./affirmation-card.component.scss']
})
export class AffirmationCardComponent implements OnInit {
  @Input() affirmation: Affirmation;
  @Output() cancel: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() delete: EventEmitter<boolean> = new EventEmitter<boolean>();
  publishedTo: string;
  constructor(private commonService: CommonService,
              public toastMessagesService: ToastMessagesService) {
    this.publishedTo = '';
  }

  ngOnInit(): void {
    this.getPublishedClasses();
  }

  getPublishedClasses() {
    console.log(this.affirmation);
    if (this.affirmation.classRestrictions && this.affirmation.classRestrictions !== 'null') {
      const tempClasses = JSON.parse(this.affirmation.classRestrictions);
      this.publishedTo = tempClasses.map(e => e.description).join(',');
      console.log(this.publishedTo);
    } else {
      this.publishedTo = 'Όλες';
    }
  }

  showAffirmation(affirmation: Affirmation) {

  }

  editAffirmation(affirmation: Affirmation) {

  }

  deleteAffirmation(affirmation: Affirmation) {
    this.delete.emit(true);
  }

  async publishAffirmation(affirmation: Affirmation) {
    try {
      await this.commonService.updateItem(`affirmations/publish?id=${affirmation.id}`, {});
      this.toastMessagesService.toastMessages(`Η δημοσίευση ολοκληρώθηκε με επιτυχία`);
      this.cancel.emit(true);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async cancelAffirmation(affirmation: Affirmation) {
    try {
      await this.commonService.updateItem(`affirmations/cancel?id=${affirmation.id}`, {});
      this.toastMessagesService.toastMessages(`Η δημοσίευση ακυρώθηκε με επιτυχία`);
      this.cancel.emit(true);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }
}
